import type { ComponentProps } from 'react';

import { normalizeSx } from '@/shared/lib/normalizeSx';
import type { Sx } from '@/shared/types/uiTypes';
import { Button } from '@/shared/ui/primitives/Button';

const selectorButtonSx: Sx = theme => ({
  paddingLeft: '8px',
  paddingRight: '8px',
  height: '24px',
  marginRight: '8px',
  backgroundColor: `${theme.palette.gx.text}33`,
  boxShadow: 'none',
  outline: 'none',
  '& .MuiSvgIcon-root': { marginRight: 0 },
  '& .MuiTypography-root': { marginLeft: '4px' },
  '&:hover': {
    backgroundColor: `${theme.palette.gx.text}66`,
    boxShadow: 'none',
    outline: 'none'
  }
});

export const SelectorButton = ({ sx, ...props }: ComponentProps<typeof Button>) => (
  <Button
    sx={[selectorButtonSx, ...normalizeSx(sx)]}
    {...props}
  />
);
